import React, { useContext, FC, useMemo, useState } from 'react'
import { MainContainer, HorizontalLine, SelectContainer, DropDownContainer } from './styles'
import { Button, ButtonText } from '../KeywordsComponents/styles'
import CustomDropDown from '../KeywordsComponents/CustomDropDown'
import { AppDataContext } from '../../../providers/AppData'
import { CityWithSpecialtiesAndTreatments } from '../../../types/homePage'

type Props = {
  keywordsForView: CityWithSpecialtiesAndTreatments[]
}

const KeywordSection: FC<Props> = ({ keywordsForView }) => {
  const [selectedCity, setSelectedCity] = useState(keywordsForView[0]?.slug)
  const { language } = useContext(AppDataContext)
  const [isVisible, setIsVisible] = useState(true)

  const onSelectCity = (e: React.MouseEvent<HTMLButtonElement>) => {
    const newCity = e.currentTarget.value
    if (newCity === selectedCity) {
      return
    }

    setIsVisible(false)
    setTimeout(() => {
      setSelectedCity(newCity)
      setIsVisible(true)
    }, 300)
  }

  const filteredByCity = useMemo(() => {
    if (!selectedCity) {
      return keywordsForView?.[0]
    }
    return keywordsForView.find((keyword) => keyword.slug === selectedCity)
  }, [selectedCity, keywordsForView])

  return (
    <MainContainer>
      <SelectContainer>
        {keywordsForView?.map?.((keyword) => (
          <Button key={keyword.id} active={selectedCity === keyword.slug} onClick={onSelectCity} value={keyword.slug}>
            <ButtonText variant="h3">{keyword.name[language]}</ButtonText>
          </Button>
        ))}
      </SelectContainer>
      <HorizontalLine />
      <DropDownContainer isVisible={isVisible}>
        {filteredByCity?.specialties.map((specialty) => (
          <CustomDropDown
            key={specialty.id}
            name={specialty.name[language]}
            specialties={specialty.treatments}
            city={filteredByCity.slug}
          />
        ))}
      </DropDownContainer>
    </MainContainer>
  )
}

export default KeywordSection
